import React from 'react';
import moment from 'moment'
import { Table, Input, DatePicker, Popconfirm, Form, Alert } from 'antd';

import config from '.././config.json';
import LoginForm from '../LoginForm.js';
import $ from 'jquery';

const FormItem = Form.Item;
const EditableContext = React.createContext();

const EditableRow = ({ form, index, ...props }) => (
    <EditableContext.Provider value={form}>
        <tr {...props} />
    </EditableContext.Provider>
);

const EditableFormRow = Form.create()(EditableRow);

// form items to edit cells
class EditableCell extends React.Component {
    render() {
        const {
            editing,
            isDate,
            dataIndex,
            title,
            record,
            index,
            ...restProps
        } = this.props;
        return (
            <EditableContext.Consumer>
                {(form) => {
                    const { getFieldDecorator } = form;
                    return (
                        <td {...restProps}>
                            {editing ? (
                                <FormItem style={{ margin: 0 }}>
                                    {getFieldDecorator(dataIndex, {
                                        rules: [{
                                            required: true,
                                            message: 'Please Input ${title}!',
                                        }],
                                        initialValue: moment(record[dataIndex]),
                                    })(<DatePicker />)}
                                </FormItem>
                            ) : (isDate ? moment(record[dataIndex]).format('l') : restProps.children)}
                        </td>
                    );
                }}
            </EditableContext.Consumer>
        );
    }
}

class AssignCertification extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            data: [],
            selectedRows: [],
            editingId: '',
            selectedRowKeys: [],
        };
        this.columns = [
            {
                title: 'Certification',
                dataIndex: 'Name',
                width: '25%',
                editable: false,
            },
            {
                title: 'Category',
                dataIndex: 'CategoryName',
                width: '15%',
                editable: false,
            },
            {
                title: 'Number of Years Valid',
                dataIndex: 'NumYearsValid',
                width: '10%',
                editable: false,
            },
            {
                title: 'Start Date',
                dataIndex: 'StartDate',
                width: '30%',
                editable: true,
            },
            {
                title: 'Action',
                dataIndex: 'Action',
                render: (text, record) => {
                    const editable = this.isEditing(record);
                    return (
                        <div>
                            {editable ? (
                                <span>
                                    <EditableContext.Consumer>
                                        {form => (
                                            <a
                                                href="javascript:;"
                                                onClick={() => this.save(form, record.Id)}
                                                style={{ marginRight: 8 }}
                                            >
                                                Save
                                            </a>
                                        )}
                                    </EditableContext.Consumer>
                                    <Popconfirm
                                        title="Sure to cancel?"
                                        onConfirm={() => this.cancel(record.Id)}
                                    >
                                        <a>Cancel</a>
                                    </Popconfirm>
                                </span>
                            ) : (
                                    <a onClick={() => this.edit(record.Id)}>Edit</a>
                                )}
                        </div>
                    );
                },
            },
        ];
    }

    // check if this row can be edited
    isEditing = (record) => {
        return record.Id === this.state.editingId;
    };

    // start editing row data
    edit(Id) {
        this.setState({ editingId: Id });
    }

    // save edited changes to rows
    save(form, Id) {
        form.validateFields((error, row) => {
            if (error) {
                return;
            }

            const newData = [...this.state.data];
            const newSelectedRows = [...this.state.selectedRows];
            // index of Id within all the data
            const index1 = newData.findIndex(item => Id === item.Id);
            if (index1 > -1) {
                // get update data for this.state.data
                const item = newData[index1];
                const date = { StartDate: row.StartDate.format() };
                newData.splice(index1, 1, {
                    ...item,
                    ...date,
                });

                // index of Id within the selectedRows data
                let index2 = this.state.selectedRows.findIndex(item => Id === item.Id);
                if (index2 > -1) {
                    // if this row is selected, update the selectedrows here and in parent class
                    newSelectedRows.splice(index2, 1, {
                        ...item,
                        ...date,
                    });
                    this.props.getData(newSelectedRows, this.state.selectedRowKeys);
                    this.setState({ selectedRows: newSelectedRows })
                }

                this.setState({ data: newData, editingId: '' });
            } else {
                newData.push(row);
                this.setState({ data: newData, editingId: '' });
            }
        });
    }

    // stop editing rows and don't update data
    cancel = () => {
        this.setState({ editingId: '' });
    };

    componentDidMount() {
        this.getData();
        //set selectedrows in the table
        this.setState({
            selectedRowKeys: this.props.renderData
        });
        LoginForm.ValidateServerToken(
            () => { this.setState({ login: false }) }, // login
        );
    }

    // when changing selected rows, update state and parent class
    onSelectChange = (selectedRowKeys, selectedRows) => {
        this.setState({ selectedRowKeys, selectedRows });
        this.props.getData(selectedRows, selectedRowKeys);
    }

    filterData(system, search) {
        let data = this.state.data;
        if (system !== 'All') {
            data = data.filter(data => data.SystemName === system);
        }

        return data;
    }

    //Generate the data
    getData = () => {
        $.ajax({
            type: 'GET',
            url: `${config.serverUrl}/api/view/getcert`,
        })
            .done((data) => {
                let date = new Date();
                var today = date.getFullYear() + '-' + (date.getMonth() + 1) + '-' + date.getDate();
                // add new data that is not in the database
                for (var key in data) {
                    //console.log("DATA:" + JSON.stringify(data[key]));
                    let newData = { SystemName: 'ESCC', StartDate: moment(today).format(), CategoryName: 'N/A', ClassID:0 }; // TODO TEST DATA REMOVE LATER
                    data[key] = { ...data[key], ...newData };
                }
                data[1].SystemName = 'TCP'; // TODO TEST DATA REMOVE LATER
                data[0].ClassID = 1; //esc
                data[1].ClassID = 2;  //tcp
                data[2].ClassID = 3;  //escd
                //get rid of TCP certification
                data[1] = data[2];
                data.pop();

                this.setState({ data: data });
            })
            .fail((jqXhr) => {
                console.log('failed to get data');
            });
    }

    render() {
        const { selectedRowKeys } = this.state;
        // Used to select rows
        const rowSelection = {
            selectedRowKeys,
            onChange: this.onSelectChange,
        };

        const components = {
            body: {
                row: EditableFormRow,
                cell: EditableCell,
            },
        };

        // set props for editable columns
        const columns = this.columns.map((col) => {
            if (!col.editable) {
                return col;
            }
            return {
                ...col,
                onCell: record => ({
                    record,
                    isDate: col.dataIndex === 'StartDate',
                    dataIndex: col.dataIndex,
                    title: col.title,
                    editing: this.isEditing(record),
                }),
            };
        });

        return (
            <div>
            <Table
                rowKey="Id"
                rowSelection={rowSelection}
                components={components}
                columns={columns}
                dataSource={this.filterData(this.props.systemFilter)}
                size="small"
                bordered
            />
            <hr />
            <Alert
                message="Selected Certifications"
                description=""
                type="info"
                showIcon
                />
            </div>
        );
    }
}

export default AssignCertification;


// WEBPACK FOOTER //
// ./src/Registration/AssignCertification.js